// @generated by protoc-gen-connect-es v1.6.1
// @generated from file omnios/v1/media.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { BatchGetMediaRequest, BatchGetMediaResponse, BatchGetMediaUrlsRequest, BatchGetMediaUrlsResponse, CopyToCdnRequest, CopyToCdnResponse, DeleteMediaRequest, GetMediaRequest, GetMediaUrlRequest, GetMediaUrlResponse, ListMediaRequest, ListMediaResponse, Media, UploadMediaRequest } from "./media_pb.js";
import { MethodKind } from "@bufbuild/protobuf";

/**
 * @generated from service omnios.v1.MediaService
 */
export const MediaService = {
  typeName: "omnios.v1.MediaService",
  methods: {
    /**
     * @generated from rpc omnios.v1.MediaService.UploadMedia
     */
    uploadMedia: {
      name: "UploadMedia",
      I: UploadMediaRequest,
      O: Media,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MediaService.GetMedia
     */
    getMedia: {
      name: "GetMedia",
      I: GetMediaRequest,
      O: Media,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MediaService.BatchGetMedia
     */
    batchGetMedia: {
      name: "BatchGetMedia",
      I: BatchGetMediaRequest,
      O: BatchGetMediaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MediaService.ListMedia
     */
    listMedia: {
      name: "ListMedia",
      I: ListMediaRequest,
      O: ListMediaResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MediaService.DeleteMedia
     */
    deleteMedia: {
      name: "DeleteMedia",
      I: DeleteMediaRequest,
      O: Media,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MediaService.GetMediaUrl
     */
    getMediaUrl: {
      name: "GetMediaUrl",
      I: GetMediaUrlRequest,
      O: GetMediaUrlResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MediaService.BatchGetMediaUrls
     */
    batchGetMediaUrls: {
      name: "BatchGetMediaUrls",
      I: BatchGetMediaUrlsRequest,
      O: BatchGetMediaUrlsResponse,
      kind: MethodKind.Unary,
    },
    /**
     * @generated from rpc omnios.v1.MediaService.CopyToCdn
     */
    copyToCdn: {
      name: "CopyToCdn",
      I: CopyToCdnRequest,
      O: CopyToCdnResponse,
      kind: MethodKind.Unary,
    },
  }
};

